import React, {useContext} from 'react';
import Context from '../OriginStoryProvider';
import DeepDiveParagraph from '../Shared/DeepDiveParagraph';

const DeepDive2 = () => {
	const { data: {content} } = useContext(Context);
	const deepDiveImages = {
		'deep_dive_2_1': {
			images: [
				{
					'img_src': `${mainScript.assetPath}images/jpg/chapter-2/powerhouse-san-antonio-canyon-1891-exterior.jpg`,
					'img_alt': ''
				},
				{
					'img_src': `${mainScript.assetPath}images/jpg/chapter-2/powerhouse-san-antonio-canyon-1891-interior.jpg`,
					'img_alt': ''
				},		
			]
		}
	}

	return (
		<div className='chapter-2__deep-dive--2 chapter-2__deep-dive--2__container main-grid'>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<DeepDiveParagraph 
					paragraph={content.chapters.second.deep_dive_section_2.paragraph}
					elClass='chapter-2__deep-dive--2'
					chapterNum='second'
					section='deep_dive_section_2'
					deepDiveImages={deepDiveImages}
				/>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default DeepDive2;